import { useEffect, useMemo, useState } from "react";
import styles from "styles/pages/reports/reports.module.scss";

import * as echarts from "echarts";

import { Numbers } from "shared/utils/Numbers";
import { formatByType } from "../Reports";

export default function Registers({ data }) {
  const [selectedOption, setSelectedOption] = useState({
    name: "customers",
    id: "QUANTIDADE_DE_CADASTROS",
  });

  const _data = {
    QUANTIDADE_DE_CADASTROS: {
      series: ["Quantidade de cadastros"],
      value_type: "int",
      colors: ["#37EF65"],
      data: [data.map((d) => d.customers.value || 0)],
    },
  };

  const totalData = [];

  const getDataByIndex = (index) => {
    return data[index];
  };

  const memoData = useMemo(() => data, [JSON.stringify(data)]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const chartDOM = document.getElementById("registers-chart");
      const chart = echarts.init(chartDOM, null, {
        renderer: "svg",
      });
      const selectedOptionId = selectedOption.id;

      const options = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "none",
          },
          backgroundColor: "#2B2B2B",
          borderRadius: 8,
          padding: [8, 8],
          borderWidth: 0,
          textStyle: {
            color: "#FFF",
            fontSize: 10,
          },
          formatter: (params) => {
            const index = params[0].dataIndex;
            const item = getDataByIndex(index);

            const formatGrowth = (growth) => {
              if (growth === 0) return "";

              const isPositive = growth > 0;
              const color = isPositive ? "#51D9A3" : "#e48186";
              const sign = isPositive ? "+" : "";
              const arrow = isPositive ? "↑" : "↓";

              return `
                <span style="color:${color};font-weight:800;margin-left:4px;">
                  ${sign}${(growth || 0).toFixed(2)}% ${arrow}
                </span>
              `;
            };

            return `
              <div>
                <div style="background-color: rgba(55, 239, 101, 0.1);padding:8px;border-radius:8px;color:#A0A0A0;margin-bottom:5px;">
                  <div style="color:#fff;opacity:70%;line-height:16px;font-weight:600;margin-bottom:2px;">
                    ${item.date}
                  </div>

                  <span style="color:#37EF65;font-weight:700">
                    Quantidade de cadastros:
                  </span>  
                  <span style="color:#fff;margin-left:4px;">
                    ${Numbers.formatInt(+item.customers.value)} 
                  </span>  
                </div>
              </div>
            `;
          },
        },
        grid: {
          left: 0,
          right: 10,
          top: 30,
          bottom: 0,
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: data.map((d) => d.date),
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              color: "rgba(217, 217, 217, 0.5)",
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLine: {
              lineStyle: {
                color: "rgba(217, 217, 217, 0.5)",
              },
            },
            splitLine: {
              lineStyle: {
                color: "rgba(51, 51, 51, 0.55)",
                width: 1,
                type: "solid",
              },
            },
            axisLabel: {
              formatter: (value) => Numbers.formatInt(value),
              color: "rgba(217, 217, 217, 0.5)",
            },
          },
        ],
        series: _data[selectedOptionId].series.map((name, sid, series) => {
          return {
            name,
            type: "bar",
            stack: "total",
            barWidth: "80%",
            data: _data[selectedOptionId].data[sid].map((d, did) =>
              totalData[did] <= 0 ? 0 : d
            ),
            label: {
              show: sid == series.length - 1,
              position: "top",
              lineHeight: 20,
              color: "rgba(255, 255, 255, 0.8)",
              fontSize: 10,
              fontWeight: "semibold",
              formatter: (params) => {
                const index = params.dataIndex;
                const total = _data[selectedOptionId].data.reduce(
                  (acc, curr) => acc + curr[index],
                  0
                );
                if (total <= 0) return "";
                return formatByType(total, _data[selectedOptionId].value_type);
              },
            },
            itemStyle: {
              color: _data[selectedOptionId].colors[sid],
            },
          };
        }),
      };

      options && chart.setOption(options);

      const ro = new ResizeObserver(() => {
        chart.resize();
      });
      ro.observe(chartDOM);

      return () => {
        ro.unobserve(chartDOM);
        ro.disconnect();
        chart.dispose();
      };
    }
  }, [memoData, selectedOption]);

  const allEmpty = _data[selectedOption.id].data.every((c) =>
    c.every((d) => d === 0 || !d)
  );

  return (
    <div className={styles.box}>
      <div className="d-flex align-center justify-between mb-20">
        <div className="d-flex align-center gap-5">
          <p className={styles.label}>Cadastros</p>
        </div>
      </div>

      <div className={styles.chart}>
        {allEmpty ? (
          <div className={styles.emptyChart} style={{ height: 350 }}>
            <span className="text-grey">Não há dados neste período</span>
          </div>
        ) : null}

        <div id="registers-chart" style={{ width: "100%", height: 350 }} />
      </div>
    </div>
  );
}
